import React from 'react';
import { useSelector } from 'react-redux';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import { nearbyStatesResourceDefinition } from './utils/queryDefinitions';
import BreederProfileLocationLinksGroup from './BreederProfileLocationLinksGroup';

interface BreederProfileNearbyStatesProps {
  breedName: string;
  breedId: string;
  isStatePage?: boolean;
  limit?: number;
}

export default function BreederProfileNearbyStates({
  breedName,
  breedId,
  isStatePage = false,
  limit = 10
}: BreederProfileNearbyStatesProps) {
  const { locationTitle } = useSelector(({ server }: any) => server);

  const { value: statesData, isFetching } = useResourceQuery(
    nearbyStatesResourceDefinition(breedId, locationTitle, limit)
  );

  return (
    <BreederProfileLocationLinksGroup
      breedName={breedName}
      linksData={statesData}
      header={`Find ${breedName} puppies in nearby states`}
      wideLayout
      linkType="state"
      limit={limit}
      isStatePage={isStatePage}
      isFetching={isFetching}
    />
  );
}
